import styled from '@emotion/styled';

export const ContentWrapper = styled.div`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacings[3]};
  display: flex;
`;
